import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToastrServiceManager {
  constructor(private toastr: ToastrService) {}

  showSuccess(text: string, title: string = 'Parabéns!') {
    this.toastr.success(text, title);
  }

  showError(text: string, title: string = 'Algo deu errado 🙁') {
    this.toastr.error(text, title);
  }
}
